module.exports = __webpack_public_path__ + "img/leftcalf-endo-mesomorph-male.b70edec5.svg";